/* unplugin-vue-components disabled */import { render } from "./KilaKilaHeader.vue?vue&type=template&id=5c6c22a9&scoped=true"
import script from "./KilaKilaHeader.vue?vue&type=script&lang=js"
export * from "./KilaKilaHeader.vue?vue&type=script&lang=js"

import "./KilaKilaHeader.vue?vue&type=style&index=0&id=5c6c22a9&scoped=true&lang=css"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6c22a9"]])

export default __exports__